import { QuizSessionQuestion, QuizQuestionState } from './quiz-questions-state'
import { QuestionStateMachine, QuestionScore } from '@/app/question/domain/state-machine'

export function createQuestionStateMachine(question: QuizSessionQuestion,
                                           state: QuizQuestionState) {

  const score = mapQuizQuestionToQuestionStateMachineScore(question)
  return new QuestionStateMachine(state,
                                  { score: score })
}

export function mapQuizQuestionToQuestionStateMachineScore(question: QuizSessionQuestion): QuestionScore {
    const score = {
      min: question.minScore,
      max: question.maxScore,
      content: {
        min: question.contentScore.min,
        max: question.contentScore.max
      }
    }

  return score
}
